var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo011(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 54,
    viewBox: "0 0 28 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-01 1",
    clipPath: "url(#clip0_11_156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9897 53.8635C21.6971 32.7192 -6.68584 15.7724 7.79022 0.863525C0.189157 14.0658 31.0216 34.9955 11.9897 53.8635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1757 3.99855C15.673 2.7504 13.2501 3.30689 11.7608 5.24139C10.2714 7.17589 10.2874 9.74639 11.79 10.9998C13.2927 12.2533 15.7155 11.6915 17.2049 9.75699C18.6943 7.82249 18.6783 5.2467 17.1757 3.99855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5215 17.1186C15.3247 13.6577 23.1598 9.78601 28.0055 11.8769C24.963 12.0279 17.3433 17.0709 14.4417 20.7411C14.2183 20.3913 12.5215 17.1186 12.5215 17.1186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.03491 12.8362C0.0721486 15.7194 -1.15657 22.2198 2.22641 29.51C6.34875 38.3928 9.09874 39.9165 11.4897 49.0352C12.5216 32.9788 3.13864 25.9934 1.03491 12.8362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 53,
    fill: "white",
    transform: "translate(0 0.863525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo011);
export default __webpack_public_path__ + "static/media/logo-01 1.44baa05e0e4a1d4c847ef5948410f728.svg";
export { ForwardRef as ReactComponent };